{
  "level": "mt03mv3",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt03mv3",
    "objects": "AREAS.E3:mt03mv3.e3",
    "mesh": "TREES.E3:mt03mv3.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: mt3mvd3l",
      "entity_class": "CSlidingDoor",
      "piece_name": "mt3mvd3l",
      "offset": 457,
      "centroid": [
        -872.0,
        -2746.75,
        725.5
      ],
      "bbox_min": [
        -872.4000244140625,
        -2748.5,
        721.0
      ],
      "bbox_max": [
        -871.5999755859375,
        -2745.0,
        730.0
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 3.5,
        "height_z": 9.0,
        "door_width": 3.5,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -872.4000244140625,
          -2748.5,
          721.0
        ],
        [
          -872.4000244140625,
          -2745.0,
          730.0
        ],
        [
          -872.4000244140625,
          -2748.5,
          730.0
        ],
        [
          -872.4000244140625,
          -2745.0,
          721.0
        ],
        [
          -871.5999755859375,
          -2748.5,
          721.0
        ],
        [
          -871.5999755859375,
          -2745.0,
          730.0
        ],
        [
          -871.5999755859375,
          -2748.5,
          730.0
        ],
        [
          -871.5999755859375,
          -2745.0,
          721.0
        ]
      ],
      "plane_distance": 2745.0,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: mt3mvd3r",
      "entity_class": "CSlidingDoor",
      "piece_name": "mt3mvd3r",
      "offset": 1756,
      "centroid": [
        -872.0,
        -2743.25,
        725.5
      ],
      "bbox_min": [
        -872.4000244140625,
        -2745.0,
        721.0
      ],
      "bbox_max": [
        -871.5999755859375,
        -2741.5,
        730.0
      ],
      "dimensions_source": {
        "span_x": 0.800048828125,
        "span_y": 3.5,
        "height_z": 9.0,
        "door_width": 3.5,
        "door_depth": 0.800048828125,
        "leaf_depth": 0.760048828125,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -872.4000244140625,
          -2745.0,
          721.0
        ],
        [
          -872.4000244140625,
          -2741.5,
          730.0
        ],
        [
          -872.4000244140625,
          -2745.0,
          730.0
        ],
        [
          -872.4000244140625,
          -2741.5,
          721.0
        ],
        [
          -871.5999755859375,
          -2745.0,
          721.0
        ],
        [
          -871.5999755859375,
          -2741.5,
          730.0
        ],
        [
          -871.5999755859375,
          -2745.0,
          730.0
        ],
        [
          -871.5999755859375,
          -2741.5,
          721.0
        ]
      ],
      "plane_distance": -872.4,
      "authentic_texture": "chkrooftrak_h"
    }
  ],
  "tutorial_messages": []
}